export default {
  update: (state, data) => ({
    ...state,
    ...data,
  }),
}
